import React from 'react';

export const NoIcon = () => (
  <svg width="60" height="38" viewBox="0 0 60 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 0V19.7392H10.7278V24.0766H14.4556V28.3254H18.1834V32.6627H22V37H52V0" fill="white" />
    <path
      d="M7 0V19.7392H10.7278V24.0766H14.4556V28.3254H18.1834V32.6627H22V37H52V0"
      stroke="#333333"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <line y1="6" x2="60" y2="6" stroke="#333333" strokeWidth="2" strokeDasharray="4.2 4.2" />
    <path d="M28.5022 27.2385L40.8109 14.5544" stroke="#FD9800" strokeWidth="2" />
    <path d="M28.5022 14.6476L41 27.1454" stroke="#FD9800" strokeWidth="2" />
  </svg>
);
